import BaseDrawer from "@stardust/base-drawer";
import { initAccordion } from "@stardust/accordion";

class MobileMenuDrawer extends BaseDrawer {
  constructor(element) {
    super(element, {
      openClass: 'opacity-0 -translate-x-full',
      closeClass: 'opacity-0 -translate-x-full',
    });
    this._openTabletSearch = this._handleTabletSearch.bind(this);
  }

  /** Close the tablet menu, then open the existing desktop autocomplete. */
  _handleTabletSearch() {
    this.close();
    window.setTimeout(() => {
      // animationDuration (300ms) clears desktop-search.js's 150ms reopen
      // guard, so the focus below isn't swallowed as an accidental reopen.
      const searchInput = document.querySelector('[data-desktop-search] [data-search-input]');
      searchInput?.focus({ preventScroll: true });
    }, this.options.animationDuration);
  }

  /** Move the single search node into the header slot (search visible in header, no CLS) */
  moveSearchToHeader() {
    if (this._searchWrapper && this._headerSlot) {
      this._headerSlot.appendChild(this._searchWrapper);
    }
  }

  /** Move the search node into the drawer when drawer is open */
  moveSearchToDrawer() {
    if (this._searchWrapper && this._drawerSearchSlot) {
      this._drawerSearchSlot.appendChild(this._searchWrapper);
    }
  }

  onOpen() {
    this.moveSearchToDrawer();
  }

  onClose() {
    this.moveSearchToHeader();
  }

  load() {
    // Listen for open event
    document.addEventListener("mobile-menu:open", () => this.toggle());

    // Listen for close event
    document.addEventListener("mobile-menu:close", this._boundClose);

    // Single search node: lives in header on first paint (no CLS). Move to drawer when menu opens, back to header when closed.
    this._headerSlot = document.querySelector("[data-mobile-header-search-slot]");
    this._searchWrapper = this._headerSlot?.querySelector(".mobile-menu-drawer__search");
    this._drawerSearchSlot = this.element.querySelector("[data-mobile-menu-drawer-search-slot]");

    // When JS is available: show search trigger (opens mobile search drawer), hide fallback form
    if (this._searchWrapper) {
      const searchTrigger = this._searchWrapper.querySelector(".js-enabled-search-trigger");
      const tabletSearchTrigger = this._searchWrapper.querySelector("[data-tablet-menu-search]");
      const searchFallback = this._searchWrapper.querySelector(".js-fallback-search");
      if (searchTrigger && searchFallback) {
        searchTrigger.style.removeProperty("display");
        searchFallback.style.display = "none";
      }
      if (tabletSearchTrigger) {
        this._tabletSearchTrigger = tabletSearchTrigger;
        tabletSearchTrigger.style.removeProperty("display");
        tabletSearchTrigger.addEventListener("click", this._openTabletSearch);
      }
    }

    // Initialize accordion functionality for mobile navigation
    const navList = this.element.querySelector('[data-accordion="mobile-navigation"]');
    if (navList) {
      initAccordion(navList, {
        exclusive: true,
      });
    }
  }

  destroy() {
    this._tabletSearchTrigger?.removeEventListener("click", this._openTabletSearch);
    super.destroy();
  }
}

// Initialize mobile menu drawer
const init = () => {
  const mobileMenuDrawer = document.querySelector('[data-mobile-menu-drawer]');
  if (mobileMenuDrawer) new MobileMenuDrawer(mobileMenuDrawer).load();
};
init();
